exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wabident-face-selector{display:inline-block}", ""]);

// exports
